import { photoSrc } from '../api';
import type { Photo } from '../types';

/** Horizontal, scroll-snapping strip of a user's photos. */
export function PhotoGallery({ photos, name }: { photos: Photo[]; name: string }) {
  if (photos.length === 0) return null;
  return (
    <div className="gallery">
      {photos.map((p) => <img key={p.id} src={photoSrc(p.url)!} alt={name} loading="lazy" />)}
    </div>
  );
}
